import { render, staticRenderFns } from "./coupon-discount-content.vue?vue&type=template&id=4423a55b&scoped=true&"
import script from "./coupon-discount-content.vue?vue&type=script&lang=ts&"
export * from "./coupon-discount-content.vue?vue&type=script&lang=ts&"
import style0 from "./coupon-discount-content.vue?vue&type=style&index=0&id=4423a55b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4423a55b",
  null
  
)

export default component.exports